import { queryClient } from "~/plugins/vue-query";

export const getProjectId = (): number => {
  const user = queryClient.getQueryData<User>(["user"]);
  return Number(user?.latest_client_project?.id);
};
